import ConsultationAPI from '../../../APIs/LoginAPI/ConsultationAPI'
import AffiliatedFacPhyAPI from '../../../APIs/LoginAPI/AffiliatedFacPhyAPI'
import router from '../../../../router/index'
export const userConsultMembInfo = {
    state: {
        userConsultInfo: [],
        oppaResult: {},
        file: null,
        to: {
            regions: [],
            provinces: [],
            cities: [],
            hospClin: [],
            doctors: [],
            spec: []
        },
        req: {
            regions: [],
            provinces: [],
            cities: [],
            hospClin: [],
            doctors: [],
            spec: []
        },
        history: [],
        history_view: {},

        arehb: null,
        mbl: null,

        is_eligible: null,
        is_eligible_ape: null,
        related_list: []
    },
    actions: {
        toRegions({ commit }) {
            AffiliatedFacPhyAPI.regions()
                .then(res => {
                    commit('TO_REGIONS', res.data)
                })
                .catch(() => {
                    // console.error('toRegions: ', error)
                })
        },
        toProvinces({ commit }, payload) {
            AffiliatedFacPhyAPI.provinces(payload)
                .then(res => {
                    commit('TO_PROVINCES', res.data)
                })
                .catch(() => {
                    // console.error('toProvinces: ', error)
                })
        },
        toCities({ commit }, payload) {
            AffiliatedFacPhyAPI.cities(payload)
                .then(res => {
                    commit('TO_CITIES', res.data)
                })
                .catch(() => {
                    // console.error('toCities: ', error)
                })
        },
        toHospClin({ commit }, payload) {
            ConsultationAPI.hospClinConsu(payload)
                .then(res => {
                    commit('TO_HOSPCLIN', res.data)
                })
                .catch(() => {
                    // console.error('toHospClin: ', error)
                })
        },
        toDoctors({ commit }, payload) {
            AffiliatedFacPhyAPI.hospClinDialog(payload)
                .then(res => {
                    commit('TO_DOCTORS', res.data)
                })
                .catch(() => {
                    // console.error('toDoctors: ', error)
                })
        },
        toSpecialization({ commit }) {
            ConsultationAPI.specialization().then(res => {
                commit('TO_SPEC', res.data)
            })
        },
        reqRegions({ commit }, payload) {
            AffiliatedFacPhyAPI.regions(payload)
                .then(res => {
                    commit('REQ_REGIONS', res.data)
                })
                .catch(() => {
                    // console.error('reqRegions: ', error)
                })
        },
        reqProvinces({ commit }, payload) {
            AffiliatedFacPhyAPI.provinces(payload)
                .then(res => {
                    commit('REQ_PROVINCES', res.data)
                })
                .catch(() => {
                    // console.error('reqProvinces: ', error)
                })
        },
        reqCities({ commit }, payload) {
            AffiliatedFacPhyAPI.cities(payload)
                .then(res => {
                    commit('REQ_CITIES', res.data)
                })
                .catch(() => {
                    // console.error('reqCities: ', error)
                })
        },
        reqHospClin({ commit }, payload) {
            ConsultationAPI.hospClinConsu(payload)
                .then(res => {
                    commit('REQ_HOSPCLIN', res.data)
                })
                .catch(() => {
                    // console.error('reqHospClin: ', error)
                })
        },
        reqDoctors({ commit }, payload) {
            AffiliatedFacPhyAPI.hospClinDialog(payload)
                .then(res => {
                    commit('REQ_DOCTORS', res.data)
                })
                .catch(() => {
                    // console.error('reqDoctors: ', error)
                })
        },
        reqSpecialization({ commit }) {
            ConsultationAPI.specialization().then(res => {
                commit('REQ_SPEC', res.data)
            })
        },
        userConsult({ commit }, membn) {
            ConsultationAPI.consultationMemberInfo(membn)
                .then(res => {
                    commit('CONSULT_INFO', res.data)
                })
                .catch(() => {
                    // console.error(error)
                })
        },
        verifyConsult({ commit }, payload) {
            ConsultationAPI.verifyOppa(payload)
                .then(res => {
                    commit('OPPA_RESULT', res.data)
                    return res.data
                })
                .then(data => {
                    if (data.APPROVED)
                        router.push(
                            `/dashboard/consultation/request/granted?OPPAN=${data.OPPAN_NO}`
                        )
                    else router.push('/dashboard/consultation/request/denied?OPPAN=NOT%20AVAILABLE')
                })
                .catch(() => {
                    router.push('/404_NOT_FOUND')
                })
        },
        fetchSlip({ commit }, payload) {
            ConsultationAPI.fetchOppaSlip(payload)
                .then(res => {
                    commit('FILE', res.data)
                    // console.log('file')
                })
                .catch(() => {
                    router.push`/404_NOT_FOUND`
                })
        },
        fetchHistory({ commit }, payload) {
            ConsultationAPI.history(payload)
                .then(res => {
                    commit('HISTORY', res.data)
                })
                .catch(() => {
                    // console.error(error)
                })
        },
        async viewHistory({ commit }, payload) {
            await ConsultationAPI.historyView(payload)
                .then(res => {
                    commit('HISTORY_VIEW', res.data)
                })
                .catch(() => {
                    // console.error(error)
                })
        },
        displayAREHB({ commit }, payload) {
            ConsultationAPI.userAREHB(payload)
                .then(res => {
                    commit('DISPLAY_AREHB', res.data)
                })
                .catch(() => {
                    // console.error(err)
                })
        },
        displayMBL({ commit }, payload) {
            ConsultationAPI.userMBL(payload).then(res => {
                commit('DISPLAY_MBL', res.data)
            })
        },
        isEligibleForOP({ commit }, payload) {
            ConsultationAPI.eligibleOP(payload)
                .then(res => {
                    commit('IS_ELIGIBLE', res.data)
                })
                .catch(() => {
                    // console.error(error)
                })
        },
        async isEligibleForAPE({ commit }, payload) {
            await ConsultationAPI.eligibleAPE(payload)
                .then(async res => {
                    commit('IS_ELIGIBLE_APE', await res.data)
                })
                .catch(() => {
                    // console.error(error)
                })
        },
        async related_list({ commit }, payload) {
            await ConsultationAPI.relatedList(payload)
                .then(res => {
                    commit('RELATED_LIST', res.data)
                })
                .catch(() => {
                    // console.error(error)
                })
        }
    },
    mutations: {
        TO_REGIONS(state, regions) {
            state.to.regions = regions
        },
        TO_PROVINCES(state, provinces) {
            state.to.provinces = provinces
        },
        TO_CITIES(state, cities) {
            state.to.cities = cities
        },
        TO_HOSPCLIN(state, hospClin) {
            state.to.hospClin = hospClin
        },
        TO_DOCTORS(state, doctors) {
            state.to.doctors = doctors
        },
        TO_SPEC(state, spec) {
            state.to.spec = spec
        },

        REQ_REGIONS(state, regions) {
            state.req.regions = regions
        },
        REQ_PROVINCES(state, provinces) {
            state.req.provinces = provinces
        },
        REQ_CITIES(state, cities) {
            state.req.cities = cities
        },
        REQ_HOSPCLIN(state, hospClin) {
            state.req.hospClin = hospClin
        },
        REQ_DOCTORS(state, doctors) {
            state.req.doctors = doctors
        },
        REQ_SPEC(state, spec) {
            state.req.spec = spec
        },

        CONSULT_INFO(state, userConsultInfo) {
            state.userConsultInfo = userConsultInfo
        },
        OPPA_RESULT(state, oppaResult) {
            state.oppaResult = oppaResult
        },
        FILE(state, file) {
            // console.log('file: ', file)
            state.file = file
        },
        HISTORY(state, history) {
            state.history = history
        },
        HISTORY_VIEW(state, history_view) {
            state.history_view = history_view
        },
        DISPLAY_AREHB(state, arehb) {
            state.arehb = arehb
        },
        DISPLAY_MBL(state, mbl) {
            state.mbl = mbl
        },
        IS_ELIGIBLE(state, is_eligible) {
            state.is_eligible = is_eligible
        },
        IS_ELIGIBLE_APE(state, is_eligible_ape) {
            state.is_eligible_ape = is_eligible_ape
        },

        RELATED_LIST(state, related_list) {
            state.related_list = related_list
        }
    },
    getters: {
        file(state) {
            return state.file
        },
        getToRegions(state) {
            return state.to.regions
        },
        getToProvinces(state) {
            return state.to.provinces
        },
        getToCities(state) {
            return state.to.cities
        },
        getToHospClin(state) {
            return state.to.hospClin
        },
        getToDoctors(state) {
            return state.to.doctors
        },
        getToSpecs(state) {
            return state.to.spec
        },
        getReqRegions(state) {
            return state.req.regions
        },
        getReqProvinces(state) {
            return state.req.provinces
        },
        getReqCities(state) {
            return state.req.cities
        },
        getReqHospClin(state) {
            return state.req.hospClin
        },
        getReqDoctors(state) {
            return state.req.doctors
        },
        getReqSpecs(state) {
            return state.req.spec
        },

        getUserConsultInfo(state) {
            return state.userConsultInfo
        },
        getOppaResult(state) {
            return state.oppaResult
        },
        getOppaFile(state) {
            return state.file
        },
        getHistory(state) {
            return state.history
        },
        getHistoryView(state) {
            return state.history_view
        },
        getAREHB(state) {
            return state.arehb
        },
        getMBL(state) {
            return state.mbl
        },

        getEligibility(state) {
            return state.is_eligible
        },
        getEligibilityAPE(state) {
            return state.is_eligible_ape
        },

        getRelated(state) {
            return state.related_list
        }
    }
}
